import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-transfer-code-confirmation',
  templateUrl: './transfer-code-confirmation.component.html',
  styleUrls: ['./transfer-code-confirmation.component.scss']
})
export class TransferCodeConfirmationComponent implements AfterViewInit {

  constructor() { }

  @Input() form!: FormGroup;
  @Input() validationForm!: FormGroup;
  @Input() countdown!: number;
  @Input() inputControls!: string[];
  @Input() destinatario!: string;
  @Input() transferForm!: FormGroup;
  @Input() loading = false;
  @Input() transferSuccess = false;
  @Input() transferError = false;
  @Input() senCode: boolean;
  @Input() showError: string;
  @Input() showRevalidate: boolean;
  @Input() isErrorConfirmed: boolean
  
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() resend = new EventEmitter<void>();
  @Output() paste = new EventEmitter<ClipboardEvent>();
  @Output() keyUp = new EventEmitter<{ event: KeyboardEvent, index: number }>();
  @Output() keyDown = new EventEmitter<{ event: KeyboardEvent, index: number }>();

  @ViewChildren('inputField') inputFields!: QueryList<ElementRef>;


  ngAfterViewInit() {
    if (this.inputFields && this.inputFields.first) {
      this.inputFields.first.nativeElement.focus();
    }
  }

  onKeyUp(event: KeyboardEvent, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (value && !/^[0-9]*$/.test(value)) {
      input.value = value.replace(/[^0-9]/g, '');
    }

    this.keyUp.emit({ event, index });

    // Mover al siguiente campo si se agrega un caracter
    if (input.value.length === 1 && index < this.inputControls.length - 1) {
        const nextInput = this.inputFields.toArray()[index + 1].nativeElement;
        nextInput.focus();
    }

    // Mover al campo anterior si se presiona "Backspace" y el campo esta vacio
    if (event.key === 'Backspace' && input.value.length === 0 && index > 0) {
        const prevInput = this.inputFields.toArray()[index - 1].nativeElement;
        prevInput.focus();
    }
  }

  onKeyDown(event: KeyboardEvent, index: number): void {
    // Prevenir caracteres no numéricos
    if (event.key.length === 1 && !/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }

    // Permitir teclas especiales
    if (['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
      return;
    }

    this.keyDown.emit({ event, index });
  }


}
